<template>
	<div>
		<div class="wd-p-20 wd-font-bold wd-font-18">个人信息</div>
		<div class="info wd-flex wd-row-left">
			<div class="form">
				<el-form label-width="100px" label-position="left">
					<el-form-item label="头像">
						<el-upload class="avatar-uploader" action="" :show-file-list="false" :multiple="false" :http-request="upimg" accept="image/jpeg,image/png,image/jpg">
							<el-image v-if="myinfo.headpic != ''" :src="$wdpicurl(myinfo.headpic, true)" class="wd-img-80 wd-border-round"></el-image>
							<i v-else class="el-icon-plus avatar-uploader-icon" />
							<!-- <el-avatar size="large" :src="$wdpicurl(myinfo.headpic,true)"></el-avatar> -->
						</el-upload>
					</el-form-item>
					<el-form-item label="昵称"><el-input type="text" placeholder="请输入昵称" maxlength="10" v-model="myinfo.nickname"></el-input></el-form-item>
					<el-form-item label="姓名"><el-input placeholder="请输入姓名" maxlength="10" v-model="myinfo.name"></el-input></el-form-item>
					<el-form-item label="性别">
						<el-radio-group v-model="myinfo.sex">
							<el-radio label="男">男</el-radio>
							<el-radio label="女">女</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="生日"><el-date-picker v-model="myinfo.birthday" type="date" placeholder="选择日期"></el-date-picker></el-form-item>
					<div class="wd-theme-999 wd-m-l-100 wd-m-b-20">
						提示：修改密码、手机等信息到
						<span class="wd-blue wd-cursor wd-m-l-10" @click="gotosafe">安全设置</span>
					</div>
					<el-form-item><el-button type="primary" @click="save">确定保存</el-button></el-form-item>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Myinfo',
	data() {
		return {
			myinfo: {}
		};
	},
	methods: {
		upimg(param) {
			var file = param.file;
			console.log("upimg");
			console.log(file);
			this.$wdupimg(file).then(response => {
				return new Promise((resolve) => {
					this.myinfo.headpic=response.value;
					this.$wd_request('editmeminfo', { act: 'headpic', value: response.value }).then(response2 => {
						if (response2.rs === 0) {
							this.$message({
								message: '头像修改成功',
								type: 'success'
							});
						}
						resolve();
					});
				});
			});
		},
		save() {
			var indata = {
				nickname: this.myinfo.nickname,
				name: this.myinfo.name,
				sex: this.myinfo.sex,
				birthday: this.myinfo.birthday,
				act: 'webmyinfo'
			};
			this.$wd_request('editmeminfo', indata)
				.then(() => {
					this.$wd_toast('修改成功');
				})
				.catch(data => {
					this.$wd_toast(data.msg, 'error');
				});
		},
		loaddata() {
			this.$wd_request('meminfo', {}, true, '.memdetail')
				.then(data => {
					this.myinfo = data.value;
				})
				.catch(data => {
					this.$wd_toast(data.msg, 'error');
				});
		},
		gotosafe() {
			this.$parent.setflag('Safe');
		}
	},
	created() {
		this.loaddata();
	}
};
</script>

<style lang="scss" scoped>
.form {
	width: 400px;
	padding: 20px 50px;
}
</style>
